"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");

var DefaultSDP_1 = require("../sdp/DefaultSDP");

var BaseTask_1 = require("./BaseTask");
/*
 * [[SetRemoteDescriptionTask]] asynchronously calls [[setRemoteDescription]] on the
 * peer connection and then waits for the tracks to be added and for the ICE connection
 * to complete.
 */


var SetRemoteDescriptionTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(SetRemoteDescriptionTask, _BaseTask_1$default);

  var _super = _createSuper(SetRemoteDescriptionTask);

  function SetRemoteDescriptionTask(context) {
    var _this;

    _classCallCheck(this, SetRemoteDescriptionTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'SetRemoteDescriptionTask';
    return _this;
  }

  _createClass(SetRemoteDescriptionTask, [{
    key: "cancel",
    value: function cancel() {
      if (this.cancelICEPromise) {
        this.cancelICEPromise();
      }
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var peer, sdp, sdpInactiveVideoOffer, sdpInactiveVideoAnswer, updatedAnswer, offer, answer, remoteDescription;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                peer = this.context.peer;

                if (!peer) {
                  this.logAndThrow('session does not have peer connection; bypass set remote description');
                }

                sdp = this.context.sdpAnswer;
                sdp = new DefaultSDP_1.default(sdp).withoutServerReflexiveCandidates().sdp;

                if (this.context.audioProfile) {
                  sdp = new DefaultSDP_1.default(sdp).withAudioMaxAverageBitrate(this.context.audioProfile.audioBitrateBps).sdp;

                  if (this.context.audioProfile.isStereo()) {
                    sdp = new DefaultSDP_1.default(sdp).withStereoAudio().sdp;
                  }
                }

                if (!this.context.browserBehavior.requiresUnifiedPlan()) {
                  // Under Plan B if our offer has video, but we're not going to subscribe to
                  // any videos, ensure that the answer has video (marked inactive). If
                  // it doesn't, WebRTC will reject the SDP answer. This happens on Chrome
                  // when going from receiving one video to zero videos. The server does not
                  // provide a video m-line when there are no videos available under Plan B,
                  // thus we need to synthesize a video m-line by copying the one from the offer.
                  this.logger.info('checking for no videos (plan-b)');

                  if (this.context.videosToReceive.empty() && this.context.peer.remoteDescription) {
                    this.logger.info('have no videos and have remote description (plan-b)');
                    sdpInactiveVideoOffer = this.context.peer.localDescription.sdp;
                    sdpInactiveVideoAnswer = sdp;
                    updatedAnswer = sdpInactiveVideoAnswer;
                    offer = new DefaultSDP_1.default(sdpInactiveVideoOffer);

                    if (offer.hasVideo()) {
                      this.logger.info("offer has video (plan-b): >>>".concat(offer.sdp, "<<<"));
                      answer = new DefaultSDP_1.default(sdpInactiveVideoAnswer);
                      this.logger.info("existing answer (plan-b): >>>".concat(answer.sdp, "<<<"));

                      if (!answer.hasVideo()) {
                        this.logger.info("copying inactive video from offer into answer (plan-b); sdp answer before is >>>".concat(sdpInactiveVideoAnswer, "<<<"));
                        updatedAnswer = answer.copyVideo(sdpInactiveVideoOffer).sdp;
                      }
                    }

                    sdp = updatedAnswer;
                  }
                }

                if (new DefaultBrowserBehavior_1.default().requiresSortCodecPreferencesForSdpAnswer()) {
                  sdp = new DefaultSDP_1.default(sdp).preferH264IfExists().sdp;
                }

                this.logger.info("processed remote description is >>>".concat(sdp, "<<<"));
                remoteDescription = {
                  type: 'answer',
                  sdp: sdp,
                  toJSON: null
                };
                _context.prev = 9;
                _context.next = 12;
                return this.createICEConnectionCompletedPromise(remoteDescription);

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](9);
                throw _context.t0;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 14]]);
      }));
    }
  }, {
    key: "createICEConnectionCompletedPromise",
    value: function createICEConnectionCompletedPromise(remoteDescription) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _this3 = this;

          var checkConnectionCompleted;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  checkConnectionCompleted = function checkConnectionCompleted() {
                    if (_this3.context.peer.iceConnectionState === 'connected' || _this3.context.peer.iceConnectionState === 'completed') {
                      _this3.context.peer.removeEventListener('iceconnectionstatechange', checkConnectionCompleted);

                      resolve();
                    }
                  };

                  this.cancelICEPromise = function () {
                    if (_this3.context.peer) {
                      _this3.context.peer.removeEventListener('iceconnectionstatechange', checkConnectionCompleted);
                    }

                    reject(new Error("".concat(_this3.name(), " got canceled while waiting for the ICE connection state")));
                  };

                  this.context.peer.addEventListener('iceconnectionstatechange', checkConnectionCompleted);
                  _context2.prev = 3;
                  _context2.next = 6;
                  return this.context.peer.setRemoteDescription(remoteDescription);

                case 6:
                  this.logger.info('set remote description, waiting for ICE connection');
                  checkConnectionCompleted();
                  _context2.next = 13;
                  break;

                case 10:
                  _context2.prev = 10;
                  _context2.t0 = _context2["catch"](3);
                  reject(_context2.t0);

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[3, 10]]);
        }));
      });
    }
  }]);

  return SetRemoteDescriptionTask;
}(BaseTask_1.default);

exports.default = SetRemoteDescriptionTask;